import { CreatorIcon } from "app/components/Icons";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import CustomTooltip from "app/components/Tooltip";
import React from "react";

interface CustomProps {
  value: string;
}

const Creator: React.FC<CustomProps> = ({ value }) => {

  return (
    <>
      <button className="flex items-center justify-between w-full min-w-0 overflow-hidden p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-secondary">
        <CustomTooltip text="Creator" className="flex items-center min-w-0">
          <div className="flex items-center gap-1 w-full min-w-0">
            <CreatorIcon size={20} color="#79808A" />
            <MemberProfileAvatar
              id={value}
              containerClassName="min-w-0"
              circleClassName="!size-4"
              initialsClassName=" !text-[8px]"
            />
          </div>
        </CustomTooltip>
      </button>
    </>
  );
};

export default Creator;
